import moment from "moment/moment";
import 'moment/locale/pt-br'
moment.locale('pt-br')
import i18next from "i18next"
import ptBR from "../locales/pt-BR.json"

// Instância própria: estes helpers rodam fora do React e não dependem da inicialização global do i18n.
const i18n = i18next.createInstance({
    lng: "pt-BR",
    resources: { "pt-BR": { translation: ptBR } },
    interpolation: { escapeValue: false }
}, () => {})

export const isEmailValid = (email) => {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}

export const describeDateTime = dateStr => {
    if (!dateStr) {
        return "N/D"
    }
    return moment(dateStr).format("DD/MM/YY HH:mm:ss")
}

export const describeDate = (dateStr, format) => {
    if (!dateStr) {
        return "N/D"
    }

    return moment(dateStr).format(format || "DD/MM/YY")
}


export const describeMoney = (value) => {
    return `R$ ${parseFloat(value || 0).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
}

// A notificação é agendada por minuto: o segundo que o navegador carrega junto
// só faz a hora gravada divergir da que o usuário escolheu.
export const removeSeconds = (date) => {
    if (!date) {
        return null
    }

    return moment(date).seconds(0).milliseconds(0).toDate()
}

export const removeHour = (date, utc = false) => {
    let dateStr = moment(date).format('YYYY/MM/DD')
    dateStr = utc ? moment.utc(dateStr).toISOString(false) : moment(dateStr).toISOString(false)
    return dateStr
}

export const isNotEmpty = (collection) => {
    return Array.isArray(collection) && collection.length > 0
}

export const clearCollection = (colletion) => {
    if (Array.isArray(colletion)) {
        while (colletion.length > 0) colletion.pop();
    }
}

export const getCompanyOption = (empresa) => {
    // A listagem de empresas traz 'S'/'N'; o vínculo do usuário traz booleano.
    const dashboardIA = empresa.DashboardIA === 'S' || empresa.DashboardIA === true
    return {
        label: i18n.t("empresa.seletor.opcao.label", { nome: empresa.RazaoSocial?.trim() || empresa.Fantasia || "N/D", id: empresa.idEmpresa }),
        value: empresa.idEmpresa,
        nome: empresa.Fantasia || "N/D",
        id: empresa.id,
        CNPJ: empresa.CNPJ,
        RazaoSocial: empresa.RazaoSocial,
        dashboardInicial: empresa.tipo ? empresa.tipo.dashboard_inicial: 'Padrão Food Service',
        dashboardIA
    }
}

const normalizarPesquisa = (texto) => {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
}

// O rótulo traz a razão social; a pesquisa também precisa achar a empresa pelo nome fantasia.
const empresaCombina = (option, termo) => {
    return normalizarPesquisa(`${option.label} ${option.nome || ""}`).includes(normalizarPesquisa(termo.trim()))
}

export const filtrarEmpresas = (options, termo) => {
    return options.filter(option => empresaCombina(option, termo))
}

export const filtrarEmpresaSelect = (candidate, termo) => {
    return empresaCombina(candidate.data, termo)
}

export const getVinculoCompanyOption = (vinculo) => {
    return getCompanyOption(vinculo.empresa)
}

export const getCompanies = (user, opcaoTodas) => {
    const tmpCompanies = opcaoTodas === true ? [{label: "Todas", value: ""}] : []
    if (user) {
        for (const vinculo of (user.vinculos || []).filter(e => ["A", "T"].find(status => status == e.vinculo_status))) {
            tmpCompanies.push(getVinculoCompanyOption(vinculo))
        }
    }
    return tmpCompanies
}

// O administrador opera empresas com as quais não tem vínculo: recebe todas as empresas carregadas
// em state.Profile.empresas, e a inicial é a do próprio vínculo, quando houver. Devolve null
// enquanto não há usuário ou a lista do administrador ainda não chegou.
export const getEmpresasDoUsuario = (user, empresas) => {
    if (!user) return null
    const isAdmin = Boolean(user.usuario_info?.perfil?.administrador)
    if (isAdmin && !Array.isArray(empresas)) return null

    const doVinculo = getCompanies(user)
    const opcoes = isAdmin ? empresas.map(empresa => getCompanyOption(empresa)) : doVinculo
    const inicial = doVinculo.find(vinculo => opcoes.some(opcao => opcao.value === vinculo.value)) || opcoes[0] || null
    return { opcoes, inicial }
}

export const getCompaniesValuesByOptions = (options) => {
    return (options || []).map(company => company.value)
}

export const describeDiff = (A, B, numberOnly = false) => {
    A = parseFloat(A)
    B = parseFloat(B)

    const diff = A && B ? (100 * Math.abs((B - A) / B)).toFixed(2) : 0

    if (numberOnly) {
        return parseInt(diff)
    }

    return A >= B ? `+ ${diff} %` : `- ${diff} %`
}

export const describePercentage = (A, B, numberOnly = false) => {
    A = parseFloat(A)
    B = parseFloat(B)

    const diff = A && B ? (100 * Math.abs(A / B)).toFixed(2) : 0

    if (numberOnly) {
        return parseInt(diff)
    }

    return A >= B ? `+ ${diff} %` : `- ${diff} %`
}

export const describeDiffColor = (A, B) => {
    A = parseFloat(A)
    B = parseFloat(B)

    return A >= B ? "success" : "warning"
}

export const abbreviateNumber = (num, fixed) => {
    if (num === null) {
        return null
    } // terminate early
    if (num === 0 || num === undefined) {
        return "0"
    } // terminate early
    fixed = !fixed || fixed < 0 ? 0 : fixed // number of decimal places to show
    var b = num.toPrecision(2).split("e"), // get power
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
        c =
            k < 1
                ? num.toFixed(0 + fixed)
                : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
        d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
        e = d + ["", "K", "M", "B", "T"][k] // append power
    return e
}

export const isCollectionEmpty = (collection) => {
    return !Array.isArray(collection) || collection.length === 0
}

/**
 * Períodos identificados por nome. Qualquer outro valor é tratado como uma data dentro do mês
 * desejado, que é o formato devolvido por getMonths().
 */
const PERIODOS_NOMEADOS = {
    today: () => ({ inicio: moment().startOf('day'), fim: moment().endOf('day') }),
    yesterday: () => ({ inicio: moment().subtract(1, 'day').startOf('day'), fim: moment().subtract(1, 'day').endOf('day') }),
    lastDays: () => ({ inicio: moment().subtract(6, 'day'), fim: moment() }),
    lastWeek: () => ({ inicio: moment().startOf('week'), fim: moment().endOf('week') }),
    thisMonth: () => ({ inicio: moment().startOf('month'), fim: moment().endOf('month') }),
    lastMonth: () => ({ inicio: moment().subtract(1, 'month').startOf('month'), fim: moment().subtract(1, 'month').endOf('month') })
}

export const getDatasPeloPeriodo = (periodo, inicio, fim, formatado = true) => {
    if (periodo && periodo !== "Selecione") {
        let dateStartStr
        let dateEndStr
        if (periodo !== 'period') {
            const periodoNomeado = PERIODOS_NOMEADOS[periodo]
            const intervalo = periodoNomeado
                ? periodoNomeado()
                : { inicio: moment(periodo).startOf('month'), fim: moment(periodo).endOf('month') }

            dateStartStr = formatado ? intervalo.inicio.format('YYYY-MM-DD 00:00:00') : intervalo.inicio
            dateEndStr = formatado ? intervalo.fim.format('YYYY-MM-DD 23:59:59') : intervalo.fim
        } else {
            dateStartStr = inicio ? (formatado ? moment(inicio).format('YYYY-MM-DD 00:00:00') : moment(inicio)): null
            dateEndStr = fim ? (formatado ? moment(fim).format('YYYY-MM-DD 23:59:59') : moment(fim)) : null
        }

        if (dateStartStr && dateEndStr) {
            return {inicio: dateStartStr, fim: dateEndStr}
        }
    }

    return null
}

export const checkIsMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const isTouchDevice = () => {
    if (typeof navigator === "undefined") return false
    return navigator.maxTouchPoints > 1 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const checkIsTablet = () => {
    if (typeof window === "undefined" || typeof navigator === "undefined") return false
    return isTouchDevice() &&
        Math.min(window.innerWidth, window.innerHeight) <= 1024 &&
        window.innerWidth > 480
}

export const getMonths = () => {
    const monthsOptions = []
    for (let i = 0; i <= 11; i++) {
        monthsOptions.push({
            label: moment().subtract(i, "month").format("MMMM/YY"),
            value: moment().subtract(i, "month").format("YYYY-MM-DD")
        })
    }
    return monthsOptions
}

export const getPeriodos = (selecione = true, retornaPrimeiroPeriodo = true,  last7Days = false, lastWeek = false, months = true ) => {
    const tmpPeriods = []

    if (months) {
        const months = getMonths();
        tmpPeriods.push(...months)
    } else {
        tmpPeriods.unshift({ label: "Mês", value: "month" })
    }

    let primeiroPeriodo = tmpPeriods[0].value

    if (last7Days) tmpPeriods.unshift({ label: "Últ. 7 dias", value: 'lastDays' })
    if (lastWeek) tmpPeriods.unshift({ label: "Últ. semana", value: 'lastWeek' })

    if (selecione)  tmpPeriods.unshift({ label: "Selecione", value: null })

    tmpPeriods.push({ label: "Personalizado", value: "period" })

    return retornaPrimeiroPeriodo ? { primeiroPeriodo, tmpPeriods }: {tmpPeriods}
}

/*
 * Casa um intervalo de datas com uma das opcoes do combo de periodo.
 *
 * Devolve sempre um escalar. Devolver a lista do filter (IW-342) fazia o moment
 * interpretar o valor como [ano, mes, dia]: o ano saia do parseInt do primeiro
 * item e o mes, ausente, caia no default 0 — janeiro — sem invalidar a data.
 */
export const getPeriodoPorData = (periodos, inicio, fim) => {
    const personalizado = periodos[periodos.length - 1].value

    const cobreMesInteiro = moment(inicio).date() === 1 &&
        moment(fim).date() === moment(inicio).endOf("month").date()
    if (!cobreMesInteiro) return personalizado

    const rotulo = moment(inicio).format("MMMM/YY")
    const mes = periodos.find(periodo => periodo.label === rotulo)

    return mes ? mes.value : personalizado
}

export const getPeriodsStartEndDateByType = (periodType) => {
    let periodStart, periodEnd
    if (periodType === "month") {
        periodStart = moment().startOf("month")
        periodEnd = moment().endOf("month")
    } else if (periodType === "period") {
        periodStart = moment().subtract(1, "month")
        periodEnd = moment()
    } else if (periodType === "lastDays") {
        periodStart = moment().subtract(6, "day")
        periodEnd = moment()
    } else if (periodType === "lastWeek") {
        periodStart = moment().startOf("week")
        periodEnd = moment().endOf("week")
    } else if (periodType === "today") {
        periodStart = moment()
        periodEnd = moment()
    } else if (periodType === "yesterday") {
        periodStart = moment().subtract(1, "day")
        periodEnd = moment().subtract(1, "day")
    }
    return {periodStart, periodEnd}
}

export const convertBlobToFile = (blob, fileName, options = {}) => {
  return new File([blob], fileName, {
    type: blob.type,
    lastModified: new Date().getTime(),
    ...options
  });
};

